import { createStyles, lighten, makeStyles, Theme } from '@material-ui/core';

export const useIconStyle = makeStyles(
  () =>
    createStyles({
      root: {
        display: 'inline-block',
        flexShrink: 0,
        userSelect: 'none',
        width: '1em',
        height: '1em',
        lineHeight: 1,
      },
      sadFace: {
        display: 'inline-block',
        flexShrink: 0,
        userSelect: 'none',
        width: '3.875em',
        height: '3.9375em',
        lineHeight: 1,
      },
    }),
  { name: 'SicrediIcon' }
);

export const useListTableStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      box: {
        borderRadius: 4,
        backgroundColor: 'white',
        '& $data, & $action:not(th)': {
          borderBottomColor: theme.palette.divider,
        },
      },
      head: {
        padding: theme.spacing('5px', 2),
        minHeight: 35,
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '20px',
        borderBottom: 'none',
      },
      data: {
        padding: theme.spacing('10px', 2),
        minHeight: 50,
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '24px',
      },
      action: {
        width: 50,
        padding: `0 !important`,
        '& > .MuiTableCell-body': {
          padding: '5px 5px',
        },
      },
      recursoTable: {
        paddingTop: theme.spacing(3),
      },
      actionButton: {
        fontSize: 20,
        padding: 0,
      },
      successRow: {
        '&[class*="MuiTableRow-root"] [class*="MuiTableCell-root"]': {
          backgroundColor: theme.palette.primary.light,
        },
      },
      dangerRow: {
        '&[class*="MuiTableRow-root"] [class*="MuiTableCell-root"]': {
          backgroundColor: theme.palette.error.light,
        },
      },
      actionDanger: {
        '&[class*="MuiIconButton-root"]:not(:disabled)': {
          color: theme.palette.error.main,
        },
      },
    }),
  { name: 'ListTable' }
);

export const useRotateAnimation = makeStyles(
  () =>
    createStyles({
      '@keyframes rotateComplete': {
        '100%': {
          transform: 'rotate(360deg)',
        },
      },
      '@keyframes rotateHalf': {
        '100%': {
          transform: 'rotate(180deg)',
        },
      },
      '@keyframes rotateHalfCounterClock': {
        '100%': {
          transform: 'rotate(-180deg)',
        },
      },
      complete: {
        animation: '$rotateComplete 1s linear infinite',
      },
      completeOnce: {
        animation: '$rotateComplete 500ms linear forwards',
      },
      half: {
        animation: '$rotateHalf 500ms linear forwards',
      },
      halfCouterClock: {
        animation: '$rotateHalfCounterClock 500ms linear forwards',
      },
    }),
  { name: 'Rotate' }
);

export const useDatepickerStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      input: {
        cursor: 'pointer !important',
        '& .MuiInputBase-input': {
          cursor: 'pointer',
        },
      },
      icon: {
        color: theme.palette.primary.main,
        '.Mui-error &': {
          color: theme.palette.error.main,
        },
      },
      disabled: {
        cursor: 'default !important',
        '& *': {
          cursor: 'default !important',
        },
      },
    }),
  { name: 'Datepicker' }
);

export const useRadioGroupStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      fieldset: {
        '&.MuiFormControl-root': {
          margin: theme.spacing(3, 0, 0),
        },
      },
      label: {
        '&.MuiFormLabel-root': {
          fontFamily: '"Exo 2", "Arial"',
          fontWeight: 600,
          fontSize: 16,
          lineHeight: 1.5,
        },
      },
      input: {
        display: 'none',
      },
      group: {
        '&.MuiFormGroup-root': {
          flexDirection: 'row',
          '& .MuiFormControlLabel-root': {
            marginRight: theme.spacing(5),
          },
        },
      },
    }),
  { name: 'RadioGroup' }
);

export const useStatusStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      edicao: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.warning.main,
          color: theme.palette.warning.dark,
        },
      },
      cadastro: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.dark,
        },
      },
      encerrado: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.dark,
        },
      },
      analise: {
        '&.MuiChip-root': {
          backgroundColor: '#CBE5FD',
          color: '#2B517B',
        },
      },
      ajuste: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
        },
      },
      parecer: {
        '&.MuiChip-root': {
          backgroundColor: '#C0ABE0',
          color: '#573D7E',
        },
      },
      prestacaoContas: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.dark,
        },
      },
      reprovado: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.error.dark,
          color: 'white',
        },
      },
      aprovado: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.primary.main,
          color: 'white',
        },
      },
      outlinedConcluido: {
        '&.MuiChip-root': {
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
        },
      },
      outlinedCancelado: {
        '&.MuiChip-root': {
          borderColor: theme.palette.error.dark,
          color: theme.palette.error.dark,
        },
      },
      outlinedInativo: {
        '&.MuiChip-root': {
          borderColor: theme.palette.secondary.dark,
          color: theme.palette.secondary.dark,
        },
      },
      prestacaoEmAndamento: {
        '&.MuiChip-root': {
          backgroundColor: theme.palette.warning.main,
          color: theme.palette.warning.dark,
        },
      },
    }),
  { name: 'Status' }
);

export const useCardMessageStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      cardMessage: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1),
        '&.MuiCard-root': {
          display: 'flex',
          alignItems: 'center',
          padding: theme.spacing(1),
        },
      },
      iconMessage: {
        width: 24,
        height: 24,
        marginRight: theme.spacing(3),
      },
    }),
  { name: 'CardMessage' }
);

export const usePrimaryModeStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      textField: {
        '&[class*="MuiTextField-root"]': {
          '& > [class*="MuiInputLabel-root"]:not([class*="Mui-error"])': {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
          },
          '& > [class*="MuiInputBase-root"]': {
            color: theme.palette.primary.main,
            '&:not([class*="Mui-error"])::before, &:not([class*="Mui-error"])::after':
              {
                borderBottomColor: theme.palette.primary.main,
              },
            '& > [class*="MuiChip-outlined"]': {
              color: theme.palette.primary.main,
              borderColor: theme.palette.primary.main,
              '& > [class*="MuiChip-deleteIcon"]': {
                color: lighten(theme.palette.primary.main, 0.3),
              },
            },
            '& [class*="MuiIconButton-root"]': {
              color: theme.palette.primary.main,
            },
          },
        },
      },
      customTextFieldChip: {
        backgroundColor: 'transparent !important',
        color: theme.palette.primary.main + ' !important',
        borderColor: theme.palette.primary.main + ' !important',
        borderWidth: '1px !important',
        borderStyle: 'solid !important',
        '& [class*="MuiChip-deleteIcon"]': {
          color: lighten(theme.palette.primary.main, 0.3),
        },
        '& [class*="MuiIconButton-root"]': {
          color: theme.palette.primary.main,
        },
      },
    }),
  { name: 'PrimaryMode' }
);

export const useDarkModeStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      textField: {
        '&[class*="MuiTextField-root"]': {
          '& > [class*="MuiInputLabel-root"]:not([class*="Mui-error"])': {
            color: theme.palette.common.white,
          },
          '& [class*="Mui-error"]': {
            color: theme.palette.error.light,
            '&::after': {
              borderBottomColor: theme.palette.error.light,
            },
            '& [class*="MuiIconButton-label"]': {
              color: theme.palette.common.white,
            },
          },
          '& > [class*="MuiInputBase-root"]': {
            color: theme.palette.common.white,
            '&:not([class*="Mui-error"])::before, &:not([class*="Mui-error"])::after':
              {
                borderBottomColor: theme.palette.common.white,
              },
            '& > [class*="MuiChip-outlined"]': {
              color: theme.palette.common.white,
              borderColor: theme.palette.common.white,
              '& > [class*="MuiChip-deleteIcon"]': {
                color: theme.palette.common.white,
              },
            },
            '& [class*="MuiIconButton-root"]': {
              color: theme.palette.common.white,
            },
          },
        },
      },
      customTextFieldChip: {
        backgroundColor: 'transparent !important',
        color: theme.palette.common.white + ' !important',
        borderColor: theme.palette.common.white + ' !important',
        borderWidth: '1px !important',
        borderStyle: 'solid !important',
        '& [class*="MuiChip-deleteIcon"]': {
          color: theme.palette.common.white,
        },
        '& [class*="MuiIconButton-root"]': {
          color: theme.palette.common.white,
        },
      },
    }),
  { name: 'DarkMode' }
);
